import React from 'react';
import { Provider } from 'react-redux';

import Base from './Base.jsx';

import NFTCollectionList from '../Components/NFTCollectionList/index.jsx';

import Store from '../Store/index.js';


class EntryPoint extends Base {
  id() {
    return 'cs-nft-list';
  }

  renderElement(element) {
    return (
      <Provider store={Store}>
        <NFTCollectionList />
      </Provider>
    );
  }
}


export default EntryPoint;
